import { gql } from "@apollo/client";

export const GET_USER_PAYMENTS = gql`
  query getPayments($pagination: Pagination, $all: Boolean) {
    getUserPayments(pagination: $pagination, all: $all) {
      cardType
      cardNumber
      depositAmount
      depositDate
      paymentOption
      internalId
      hashId
      status
      receiptUrl
    }
  }
`;

// The receipt of a top-up paid straight to the Ledger (USDT, TRC20).
export const GET_CRYPTO_RECEIPT = gql`
  query getCryptoReceipt($hashId: String!) {
    getCryptoReceipt(hashId: $hashId) {
      number
      status
      testnet
      createdAt
      paidAt
      creditedAt
      amountUsd
      payerEmail
      payerName
      payerOrganization
      network
      asset
      amount
      fromAddress
      toAddress
      txHash
      explorerUrl
      amlStatus
      amlCheckedAt
      amlChecks {
        name
        status
        detail
        score
        checkedAt
      }
    }
  }
`;
